<template>
  <span
    class="info-feature"
    v-if="feature.hint"
    @mouseenter="activated"
    @mouseleave="deactivated"
  >
    <img src="https://sirvwebsite.sirv.com/assets/info.svg">
    <span class="info-feature-message" :class="{active: status}">{{feature.hint}}</span>
  </span>
</template>
<script>
export default {
  name: 'hint',
  data() {
    return {
      status: false
    }
  },
  props: {
    feature: {
      type: Object
    }
  },
  methods: {
    activated() {
      this.status = true
    },
    deactivated() {
      this.status = false
    }
  }
}
</script>
<style lang="scss" scoped>
.info-feature {
  background-color: transparent;
  margin-left: 5px;
  cursor: pointer;
  position: relative;
  &-message {
     display: none;
     position: absolute;
     text-align: left;
     max-width: 300px;
     min-width: 300px;
     border-radius: 5px;
     padding: 15px;
     background-color: rgba(0,0,0, .65);
     bottom: 125%;
     left: 50%;
     transform: translateX(-50%);
     color: #fff;
     z-index: 999;
    font-size: 12px;
    line-height: 1.5;
     &.active {
       display: flex;
     }
    &::after {
      position: absolute;
      bottom: -5px;
      left: 50%;
      margin-left: -5px;
      width: 0;
      border-top: 5px solid #000;
      border-top: 5px solid hsla(0, 0%, 20%, 0.9);
      border-right: 5px solid transparent;
      border-left: 5px solid transparent;
      content: " ";
      font-size: 0;
      line-height: 0;
    }
  }
}
</style>
